/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listTeamMembershipsParamsCursorMax = 512;

export const listTeamMembershipsParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listTeamMembershipsParamsLimitDefault = 50;
export const listTeamMembershipsParamsLimitMax = 100;

export const ListTeamMembershipsParams = zod.object({
  includeEnded: zod.string().optional(),
  cursor: zod
    .string()
    .min(1)
    .max(listTeamMembershipsParamsCursorMax)
    .regex(listTeamMembershipsParamsCursorRegExp)
    .optional(),
  limit: zod
    .int()
    .min(1)
    .max(listTeamMembershipsParamsLimitMax)
    .default(listTeamMembershipsParamsLimitDefault),
});

export type ListTeamMembershipsParams = zod.input<typeof ListTeamMembershipsParams>;
export type ListTeamMembershipsParamsOutput = zod.output<typeof ListTeamMembershipsParams>;
